export default __webpack_public_path__ + "static/media/Rod of the Resplendent Phoenix.fc1819ea.jpg";